// import { HeaderElement, HeaderElementType } from "../types";

import {HeaderElement, HeaderElementType } from "src/types";

const resourcesHeader = {
  title: 'Resources',
  redirectLink: '',
  actionType: HeaderElementType.DRPODOWN,
  dropdown: [
    {
      title: 'EXPAREL Enrollment Form',
      redirectLink: 'https://www.exparelpro.com/Enrollment-Form.pdf',
    },
    {
      title: 'How To Order',
      redirectLink: 'https://www.exparelpro.com/how-to-order-exparel',
    },
  ]
};

export const PublicHeader: HeaderElement[] = [
  {
    title: 'Practice Registration',
    redirectLink: '/enrollments/new',
    actionType: HeaderElementType.ROUTE,
  },
];

export const AuthenticatedManufactureHeader: HeaderElement[] = [
  {} as unknown as HeaderElement,
  {} as unknown as HeaderElement,
 
  resourcesHeader,
   {
    title: 'EOB Warehouse',
    redirectLink: '/ExplanationOfBenefit',
    actionType: HeaderElementType.BUTTON,
  },
];
export const AuthenticatedHCPHeader: HeaderElement[] = [
  
  {
    title: 'Cases',
    redirectLink: '/cases',
    actionType: HeaderElementType.ROUTE,
  },
 
  {
    title: 'Submit Request',
    redirectLink: '/cases/new',
    actionType: HeaderElementType.ROUTE,
  },
  
  resourcesHeader,
   {
    title: 'EOB Warehouse',
    redirectLink: '/ExplanationOfBenefit',
    actionType: HeaderElementType.BUTTON,
  },
  
];


